import dayjs from 'dayjs';
import { ICustomerAccount } from 'app/shared/model/customer-account.model';
import { IOrganisation } from 'app/shared/model/organisation.model';
import { ISupplier } from 'app/shared/model/supplier.model';
import { CustomerType } from 'app/shared/model/enumerations/customer-type.model';
import { CustomerStatus } from 'app/shared/model/enumerations/customer-status.model';
import { SendToMandateStatus } from 'app/shared/model/enumerations/send-to-mandate-status.model';

export interface ICustomer {
  id?: number;
  customerType?: keyof typeof CustomerType;
  customerStatus?: keyof typeof CustomerStatus | null;
  sendToMandate?: keyof typeof SendToMandateStatus | null;
  createdTimestamp?: dayjs.Dayjs | null;
  customerAccount?: ICustomerAccount | null;
  organisation?: IOrganisation | null;
  suppliers?: ISupplier[] | null;
}

export const defaultValue: Readonly<ICustomer> = {};
